﻿import * as emoji from 'node-emoji';

const searchRetriever = (function searchRetriever() {
	const loadMoreBtn = document.getElementById('load-more-btn');
	const scrollToTopBtn = document.getElementById('scroll-to-top-btn');
	const loadingSpinner = document.getElementById('loading-spinner');
	let filterOptionsDesktopElements = document.querySelectorAll(".filter__container .custom-checkbox input[type='checkbox']");
	let clearAllFiltersBtn = document.querySelector('[data-clear-filter]');
	const filterGroups = document.querySelectorAll('[data-filter-group]');
	const footerCount = document.querySelector('span[data-results-footer-count]');
	const footerTotal = document.querySelector('span[data-results-footer-total]');
	
	document.querySelectorAll('.search-tabs-component--mobile-accordion').forEach((accordion) => {
		accordion.addEventListener('click', (event) => {
			const icon = accordion.querySelector('.search--toggle-icon');
			icon.classList.toggle('active');

			const categoryList = accordion.parentElement.querySelector('[data-accordion="search-categories"]');

			const isOpen = categoryList.classList.contains('active');

			if (isOpen) {
				// Collapse: animate to 0 height
				categoryList.style.height = categoryList.scrollHeight + 'px'; // Set to current height first
				requestAnimationFrame(() => {
					categoryList.style.height = '0px';
				});
				categoryList.classList.remove('active');
			} else {
				// Expand: set to scrollHeight and then reset to auto
				categoryList.classList.add('active');
				categoryList.style.height = categoryList.scrollHeight + 'px';

				// After transition, set to auto to allow responsive resizing
				categoryList.addEventListener('transitionend', function handler() {
					categoryList.style.height = 'auto';
					categoryList.removeEventListener('transitionend', handler);
				});
			}
		});
	});
	
	//#region Search
	const appendContentTypesToQueryParams = (queryParams) => {
		let contentTypesToSearch = [];
		const contentTypesElement = document.getElementById('contentTypesToSearch');
		if (contentTypesElement && contentTypesElement.value) {
			try {
				contentTypesToSearch = JSON.parse(contentTypesElement.value);
			} catch (e) {
				console.error('Error parsing content types:', e);
			}
		}

		if (contentTypesToSearch && contentTypesToSearch.length > 0) {
			contentTypesToSearch.forEach(contentType => {
				queryParams.append('ContentTypesToSearch', contentType);
			});
		}
	}
	const repaintCards = (data) => {
		const searchResultsContainer = document.getElementById('search-results-container');
		if (searchResultsContainer && data.renderedHtml) {
			searchResultsContainer.innerHTML = data.renderedHtml;
		}
	}
	const getCategoriesString = () => {
		let activeFilters = getActiveFilters();
		return activeFilters.length
			? activeFilters.map(option => `${option}`).join('_')
			: '';
	}
	const getQueryParams = () => {
		const currentPage = parseInt(loadMoreBtn.getAttribute('data-page') || '1');
		const contentListingWrapper = document.querySelector('.content-listing-wrapper');
		const searchTerm = contentListingWrapper.getAttribute('data-search-term') || '';
		const filterCategories = getCategoriesString();
		const sortBy = contentListingWrapper.getAttribute('data-sort') || 'recent';
		const pageSize = parseInt(contentListingWrapper.getAttribute('data-page-size') || '10');

		const queryParams = new URLSearchParams({
			SearchTerm: searchTerm,
			FilterCategories: filterCategories,
			PageSize: pageSize,
			PageNumber: currentPage,
			SortBy: sortBy
		});

		appendContentTypesToQueryParams(queryParams);

		return queryParams;
	}
	const handleSearch = (queryParams) => {
		return fetch(`/api/v2/search?${queryParams.toString()}`, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}).then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			return response.json();
		}).then(data => {
			disableFilters(data);
			updateFilterCounts()
			return data;
		});
	}
	
	const convertEmojis = (searchTerm) => {
		
		let convertedText = emoji.unemojify(searchTerm);
		convertedText = convertedText.replace(/:(.+?):/g, '$1'); //remove wrapping colons
		
		console.log(`Converted ${searchTerm} to ${convertedText}`);
		return convertedText;
	}
	//#endregion
	
	//#region Filters
	const handleFilters = () => {
		const queryParams = getQueryParams();
		queryParams.set('PageNumber', '1');
		handleSearch(queryParams)
			.then(data => {
				if (data) {
					repaintCards(data);
					$(window).scrollTop(0);
				}
				toggleFooterButtons(data.runningTotalCount, data.itemCount, queryParams.get('PageNumber'));
				updateCounts(data.runningTotalCount, data.itemCount);
			})
			.catch(error => {
				console.error('Error fetching more results:', error);
			})
			.finally(() => {
				if (loadingSpinner) loadingSpinner.style.display = 'none';
			});
	};
	const disableFilters = (data) => {
		filterGroups.forEach(filterGroup => {
			const groupedFilters = filterGroup.querySelectorAll('.custom-checkbox input[type="checkbox"]');
			groupedFilters.forEach(filter => {
				const groupHeading = filterGroup.getAttribute('data-filter-group');

				if(filterExistsInGroup(filter.getAttribute('data-value'), groupHeading, data))
				{
					enableFilter(filter)
				}
				else(
					disableFilter(filter)
				)
			})
		});
		reinitializeCheckboxes();
	};
	const filterExistsInGroup = (filterValue, groupHeading, data) => {
		if (!data || !Array.isArray(data.filters)) {
			return false;
		}

		const filterGroup = data.filters.filter(f => f.heading === groupHeading)[0];
		if (!filterGroup || !Array.isArray(filterGroup.filters)) {
			return false;
		}
		const filters = filterGroup.filters;
		if(filters.length === 0) return false;
		return filters.some(f => f && f.name === filterValue);
	}
	const enableFilter = (filter) => {
		if(filter) {
			filter.removeAttribute('disabled');
			filter.style.opacity = 1;
		}
	}
	const disableFilter = (filter) => {
		if(filter) {
			filter.setAttribute('disabled', 'true');
			filter.style.opacity = 0.5;
		}
	}
	const updateFilterCounts = () => {
		const filtersCountElements = document.querySelectorAll('[data-filter-count]');
		filtersCountElements.forEach(f => f.textContent = `(${getActiveFilters().length.toString()})`);
	}
	const getActiveFilters = () => {
		const activeFilters = [];
		filterOptionsDesktopElements.forEach(filter => {
			if (filter.checked) {
				activeFilters.push(filter.name);
			}
		});
		return activeFilters;
	}
	const clearAllFilters = () => {
		let filters = getActiveFilters();
		filters.forEach(filter => {
			let filterElement = document.querySelector(`input[name="${filter}"]`);
			if (filterElement) {
				filterElement.checked = false;
			}
		});
		reinitializeCheckboxes();
		updateFilterCounts();
		handleFilters();
	}
	const reinitializeCheckboxes = () => {
		document.querySelectorAll(".filter__container .custom-checkbox input[type='checkbox']")
			.forEach((checkbox) => {
				checkbox.addEventListener("change", handleFilters);
			});
	};
	//#endregion
	
	//#region Pagination
	const loadMoreResults = () => {
		if (loadMoreBtn) loadMoreBtn.style.display = 'none';
		if (loadingSpinner) loadingSpinner.style.display = 'block';

		const queryParams = getQueryParams();
		const nextPage = parseInt(queryParams.get('PageNumber')) + 1;
		queryParams.set('PageNumber', nextPage.toString());

		handleSearch(queryParams)
			.then(data => {
				if (data.renderedHtml) {
					appendContentCards(data);
				}
				toggleFooterButtons(data.runningTotalCount, data.itemCount, nextPage);
				updateCounts(data.runningTotalCount, data.itemCount);
			})
			.catch(error => {
				console.error('Error fetching more results:', error);
			})
			.finally(() => {
				if (loadingSpinner) loadingSpinner.style.display = 'none';
			});
	}
	const appendContentCards = (data) => {
		const searchResultsContainer = document.getElementById('search-results-container');
		searchResultsContainer.insertAdjacentHTML('beforeend', data.renderedHtml);
	}
	const updateCounts = (current, total) => {
		if (footerCount) {
			footerCount.innerText = current;
		}
		if (footerTotal) {
			footerTotal.innerText = total;
		}
	}
	const toggleFooterButtons = (count, total, nextPage) => {
		if(count >= total) {
			loadMoreBtn.style.display = 'none';
			scrollToTopBtn.style.display = '';

		} else {
			loadMoreBtn.setAttribute('data-page', nextPage.toString());
			loadMoreBtn.style.display = '';
			scrollToTopBtn.style.display = 'none';
		}
	}
	//#endregion
	
	//#region Events
	function attachEvents() {
		document.querySelectorAll(".filter__container .custom-checkbox input[type='checkbox']")
			.forEach((checkbox) => {
				checkbox.addEventListener("change", handleFilters);
			});

		document.querySelectorAll('form')
			.forEach((form) => {
				if (form.querySelector('input[type="text"]')) {
					form.addEventListener('submit', function () {
						form.querySelectorAll('input[type="text"]').forEach(function (input) {
							input.value = convertEmojis(input.value);
						});
					});
				}
			})
		
		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', loadMoreResults);
		}
		
		if (clearAllFiltersBtn) {
			clearAllFiltersBtn.addEventListener('click', clearAllFilters);
		}
	}
	function init() {
		attachEvents();
	}
	return {
		init: init
	};
	//#endregion
}());

document.addEventListener('DOMContentLoaded', () => {
	searchRetriever.init();
});